import { fetchInstance } from '@/utils/fetchInstance.ts';

export interface PendingExpedition {
  pendingExpeditionId: string;
  ticketRarity: 0 | 1 | 2 | 3 | 4;
  status: 'pending' | 'started' | 'expired';
  expiresAt: string;
}

export interface StartExpeditionResponse {
  expeditionId: string;
}

export const getPendingExpedition = async (
  pendingExpeditionId: string
): Promise<PendingExpedition> => {
  return await fetchInstance.get<PendingExpedition>(
    `expedition/pending/${pendingExpeditionId}`
  );
};

export const selectExpeditionPokemon = async (
  pendingExpeditionId: string,
  allyOwnedPokemonId: string
): Promise<StartExpeditionResponse> => {
  return await fetchInstance.put<StartExpeditionResponse>(
    `expedition/pending/${pendingExpeditionId}/pokemon`,
    { allyOwnedPokemonId }
  );
};

